import { c as _c } from "react/compiler-runtime";
import styles from "./EffektTextInput.module.scss";
export const EffektTextInput: React.FC<{
  value: string | undefined;
  onChange: (val: string) => void;
  name?: string;
  type?: string;
  placeholder?: string;
  denomination?: string;
  variant?: "rounded" | "underlined";
}> = t0 => {
  const $ = _c(16);
  const {
    value,
    onChange,
    name,
    type,
    placeholder,
    denomination,
    variant
  } = t0;
  const t1 = styles[variant || "rounded"];
  let t2;
  if ($[0] !== t1) {
    t2 = [styles.textInputWrapper, t1];
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = t2.join(" ");
  let t4;
  if ($[2] !== onChange) {
    t4 = e => onChange(e.target.value);
    $[2] = onChange;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== name || $[5] !== placeholder || $[6] !== t4 || $[7] !== type || $[8] !== value) {
    t5 = <input className={styles.textInput} value={value} onChange={t4} placeholder={placeholder} name={name} type={type} />;
    $[4] = name;
    $[5] = placeholder;
    $[6] = t4;
    $[7] = type;
    $[8] = value;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== denomination) {
    t6 = denomination && <span className={styles.denomination}>{denomination}</span>;
    $[10] = denomination;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t3 || $[13] !== t5 || $[14] !== t6) {
    t7 = <div className={t3}>{t5}{t6}</div>;
    $[12] = t3;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
};